
export class PDFLogo{
    logoSrc: string = 'assets/LOGO-ADIAL-cmjn.png';
    posXY: number = 10;
    widthHeight: number = 25;
}
export enum PDF_PARAMS {
    ORIENTATION = 'p', /** Is for portrait */
    UNIT = 'mm', /** Unit to calculate positions in document */
    FORMAT = 'a4', /** The chosen Pdf Format */
    EXTENSION = '.pdf'
}

export enum PDF_TEXTS {
    SOLVED = 'Panne résolue',
    NOT_SOLVED = 'Panne NON résolue',
    AGENT = 'Agent : ',
    DATE = 'Date : ',
    MACHINE = 'Machine : ',
    VERIFICATIONS = 'Vérifications',
    COMM = 'Commentaire : ',
    STRONG_PROOF = 'Niveau de preuve: Technicien',
    WEAK_PROOF = 'Niveau de preuve: Client'
}

export enum PDF_COLORS {
    GREEN = '#4e9b0f',
    RED = '#ac2e0f',
    BLACK = '#000000',
    BROWN = '#8f5101',
    BLUE = '#240a96'
}